import React, {PropsWithChildren, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {SlidesTopTimeAnalyticsDTO} from '../../../../incase-domain/analytics';
import {IPresentation} from '../../../../incase-domain/presentation';
import {slideIndex} from '../../../../utils/slide';
import SkeletonLoader from '../../../components/common/SkeletonLoader';
import ReportProgressBar from '../../../../incase-domain/components/report/progressBar/ReportProgressBar';
import Label from '../../../../incase-domain/components/label/Label';
import {minutesToMMSS} from '../../../../utils/dateTimeUtils';

interface SlideTimeProps {
    selectedPresentation: IPresentation;
    slideAnalytics: SlidesTopTimeAnalyticsDTO;
    isLoading: boolean;
}

function SlideTimeReport2(props: PropsWithChildren<SlideTimeProps>): JSX.Element {
    const {selectedPresentation, slideAnalytics, isLoading} = props;

    const {t} = useTranslation();

    const formattedData = useMemo(() => {
        return Object.entries(slideAnalytics).map(([key, value]) => {
            const slideData = slideIndex(selectedPresentation, key);

            return {
                id: key,
                name: slideData.name,
                value,
            };
        });
    }, [selectedPresentation, slideAnalytics]);

    const maxTime = useMemo(() => {
        return formattedData.reduce((max, slide) => Math.max(max, slide.value), 0);
    }, [formattedData]);

    return (
        <SkeletonLoader isLoading={isLoading} props={{style: {minHeight: '12rem'}}}>
            <div className="u-flex u-flex-col u-gap-3">
                <Label size="lg">{t('reportPage.slideTopTime.title')}</Label>
                <div className="u-flex u-flex-col u-gap-2 u-ml-2">
                    {formattedData.length > 0 ? (
                        formattedData.map((slide) => (
                            <ReportProgressBar
                                label={slide.name}
                                value={slide.value}
                                maxValue={maxTime}
                                score={`${minutesToMMSS(slide.value)}`}
                                hideValue
                            />
                        ))
                    ) : (
                        <Label size="md">{t('reportPage.noData')}</Label>
                    )}
                </div>
            </div>
        </SkeletonLoader>
    );
}

export default SlideTimeReport2;
